import { render, staticRenderFns } from "./simulador.vue?vue&type=template&id=e4188d18&"
import script from "./simulador.vue?vue&type=script&lang=js&"
export * from "./simulador.vue?vue&type=script&lang=js&"
import style0 from "./simulador.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports